import { RFIconProps } from "../types";

export default function CopyIcon(props: RFIconProps) {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			className={props.className || "w-6 h-6"}
		>
			<g clipPath="url(#clip0_2127_1746)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.759952 2.3999C0.339445 2.3999 0 2.7636 0 3.21415V11.1857C0 11.6362 0.339445 11.9999 0.759952 11.9999H7.64005C8.06055 11.9999 8.4 11.6362 8.4 11.1857V3.21415C8.3986 2.76402 8.05764 2.3999 7.63751 2.3999H0.759952ZM1.01341 10.9142V3.48557H7.38687V10.9142H7.38433H1.01341Z"
					fill="currentColor"
				/>
				<path
					d="M2.96711 0C2.65515 0 2.3999 0.232508 2.3999 0.516685C2.3999 0.800861 2.65515 1.03337 2.96711 1.03337H10.4911C10.6982 1.03337 10.8655 1.18579 10.8655 1.37438V9.08332C10.8655 9.36749 11.1207 9.6 11.4327 9.6C11.7447 9.6 11.9999 9.36749 11.9999 9.08332V1.37438C11.9971 0.614855 11.3221 0 10.4911 0H2.96711Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2127_1746">
					<rect width="12" height="12" fill="currentColor" />
				</clipPath>
			</defs>
		</svg>
	);
}
